<template>
  <v-layout class="pa-0">
    <v-flex xs12>
      <v-card :loading="loading || savingInvoice" :disabled="loading || savingInvoice">
        <v-card-title class="pa-0">
          <v-toolbar>
            <v-toolbar-title>Billing</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ExportInvoices>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" class="mr-2">exports</v-btn>
            </template>
          </ExportInvoices>
          <UploadArDialog></UploadArDialog>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-card-text class="mt-2" v-if="!loading">
          <v-row no-gutters>
            <v-col cols="3">
              <CustomersWithBillableSamples :invoice_samples="samplesForInvoice" @loaded="loadCustomers" @add="addToBill($event)" @remove="removeFromBill($event)"></CustomersWithBillableSamples>
            </v-col>
            <v-col>
              <BillingInvoice ref="billing_invoice" :separated_line_items="separatedLineItems" :invoice_id="bill ? bill.invoice_id : null" :billing_config="billingObject" :invoice_samples="samplesForInvoice" @remove="removeFromBill($event)" @submit_bill="submitBill"></BillingInvoice>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import BillSample from "@/views/Config/Lib/BillSample";
import moment from "moment";
export default {
    name: "index",
    components: {
      CustomersWithBillableSamples: () => import("@/views/Billing/components/CustomersWithBillableSamples"),
      BillingInvoice: () => import("@/views/Billing/components/BillingInvoice"),
      ExportInvoices: () => import("@/views/Billing/components/ExportInvoices"),
      UploadArDialog: () => import('./components/uploadArDialog')
    },
    data: () => ({
      loading: true,
      savingInvoice: false,
      bill: null,
      samplesForInvoice: [],
      separatedLineItems: [],
    }),
    watch: {
      bill: {
        deep: true,
        handler(v){
          if(v){
            this.$store.$db().model('billingInvoices').insertOrUpdate({data: v});
          }
        }
      }
    },
    computed:{
      billingObject(){
        return new BillSample({
          billingBundleDiscounts: this.$store.$db().model('billingBundleDiscounts').query().orderBy("priority").all(),
          billingPackages: this.$store.$db().model('billingPackages').query().orderBy("priority").all(),
          billingTestPairs: this.$store.$db().model('billingTestPairs').all(),
          billingTestPrices: this.$store.$db().model('billingTestPrices').all(),
          billingPromotions: this.$store.$db().model('billingPromotions').all(),
          billingSpecials: this.$store.$db().model('billingSpecials').all(),
          billingFixedPrices: this.$store.$db().model('billingFixedPrices').query().orderBy("priority").all(),
          billingSeparatedItems: this.$store.$db().model('billingSeparatedItems').query().orderBy("priority").all(),
        })
      }
    },
    mounted(){
      this.load()
    },
    methods: {
      async load(){
        this.loading = true;
        await this.$store.$db().model('names').deleteAll();
        await this.$store.$db().model('customers').deleteAll();
        await this.$store.$db().model('billings').deleteAll();
        await Promise.all([
          this.$store.$db().model('names').api().fetch(),
          this.$store.$db().model('billings').api().fetch(),
          this.$store.$db().model('billingInvoices').load({limit: 1,order_by: {key: 'invoice_id', desc: true}}),
          this.$store.$db().model('billingBundleDiscounts').load(),
          this.$store.$db().model('billingPackages').load(),
          this.$store.$db().model('billingTestPairs').load(),
          this.$store.$db().model('billingTestPrices').load(),
          this.$store.$db().model('billingPromotions').load(),
          this.$store.$db().model('billingSpecials').load(),
          this.$store.$db().model('billingFixedPrices').load(),
          this.$store.$db().model('billingSeparatedItems').load(),
        ])
        await this.generateNewBill();
        this.loading = false;
      },
      async loadCustomers(){
        //load unique customer ids from samples
        const customers = this.$store.$db().model('samples').query().where('billing_approved', false).get();
        // const customers = this.$store.$db().model('samples').query().get();
        //create a new set to store unique customer ids
        let customerIds = new Set();
        //loop through the samples and add the customer ids to the set
        for(let sample of customers){
          customerIds.add(sample.customer_id);
        }
        //convert the set to an array
        customerIds = Array.from(customerIds);
        await this.$store.$db().model('customers').api().fetch({with: 'primaryName,imperatives,contract', where_in: {key: 'id', values: customerIds}});
      },
      async generateNewBill(){
        await this.$store.$db().model('billingInvoices').load({deleteAll: false, limit:1, order_by: {key: 'invoice_id', desc: true}})
        let billingId = this.$store.$db().model('billingInvoices').query().orderBy("invoice_id", "desc").first();
        let newBill = this.$store.$db().model('billingInvoices').newItem({
          invoice_id: billingId ? billingId.invoice_id+1 : 90053
        });
        await this.$store.$db().model('billingInvoices').insert({data: newBill});
        this.bill = this.$store.$db().model('billingInvoices').query().where("$isNew", true).orderBy('invoice_id', 'desc').first();
      },
      addToBill(sample){
        console.log("ADDING TO BILL", sample);
        if(!this.$refs.billing_invoice.customer){
          this.$refs.billing_invoice.customer = Object.assign({},this.$refs.billing_invoice.customer, this.$store.$db().model('names').query().where("name_type_id", 1).where('customer_id', sample.customer_id).first())
        }
        let find = this.samplesForInvoice.find(item => item.sample_uuid === sample.uuid)
        if(!find){
          let promo = this.$refs.billing_invoice.findImperatives();
          let discount = this.$refs.billing_invoice && (this.$refs.billing_invoice.billings && this.$refs.billing_invoice.billings.discount) ? this.$refs.billing_invoice.billings.discount : null;
          // console.log(promo, 'PROMO')
          // return;
          this.samplesForInvoice.push({
            sample_tests: sample.sample_tests,
            sample_flags: sample.sample_flags,
            sample_cert_type: sample.sample_cert_type,
            customer_id: sample.customer_id,
            sample_uuid: sample.uuid,
            sample_id: sample.id,
            type: sample.sample_cert_type.name,
            description: `QA: ${sample.qa} | Lot: ${sample.lot}`,
            is_rnd: sample.is_rnd,
            ...this.billingObject.samplePrice(sample, promo, discount)
          })
          const separatedItems = this.billingObject.seperatedBillingItems(sample.customer_id, sample.sample_tests, sample.sample_flags, sample.sample_cert_type.category.uuid);
          separatedItems.forEach(item => {
            const findItem = this.separatedLineItems.find(lineItem => item.package === lineItem.package)
            if(findItem){
              findItem.quantity += 1;
              findItem.total += +item.price;
              findItem.sample_uuids.push(sample.uuid)
            }else{
              this.separatedLineItems.push({
                display_name: item.display_name,
                package: item.package,
                price: +item.price,
                quantity: 1,
                total: +item.price,
                sample_uuids: [sample.uuid]
              })
            }
          })
        }
      },
      removeFromBill(item){
        console.log(item, "remove from bill");
        const id = item.sample_uuid ? item.sample_uuid : item.uuid
        let indexOf = this.samplesForInvoice.findIndex(sample => sample.sample_uuid === id);
        let indedOfSeparatedItem = this.separatedLineItems.findIndex(lineItem => lineItem.sample_uuids.includes(id));
        if(indedOfSeparatedItem >= 0){
          let lineItem = this.separatedLineItems[indedOfSeparatedItem];
          if(lineItem.quantity > 1){
            lineItem.quantity -= 1;
            lineItem.total -= +lineItem.price;
          }else{
            this.separatedLineItems.splice(indedOfSeparatedItem, 1)
          }
        }
        if(indexOf >=0) this.samplesForInvoice.splice(indexOf, 1)
      },
      clearInvoice(){
        this.samplesForInvoice = [];
      },
      async submitBill(){
        if(this.samplesForInvoice.length === 0 || !this.$refs.billing_invoice.customer) return;
        this.savingInvoice = true;
        const model = this.$store.$db().model('billingInvoices')
        let bill = model.query().where('$isNew', true).orderBy('invoice_id', 'desc').first();
        let invoiceItems = this.samplesForInvoice.map((sample) => ({
          description: sample.description,
          basePrice: sample.basePrice,
          customPrice: sample.customPrice,
          customer_id: sample.customer_id,
          discounts: sample.discounts.map(discount => ({discount: discount.discount, name: discount.name})),
          extra_costs: sample.extra_costs,
          finalPrice: sample.finalPrice,
          package: sample.package.quick_books_name ? sample.package.quick_books_name : sample.package.name,
          percentDiscount: sample.percentDiscount,
          sample_id: sample.sample_id,
          sample_uuid: sample.sample_uuid,
          tests: sample.tests.map(test => ({disabled: test.disabled ? test.disabled : false, basePrice: test.basePrice, finalPrice: test.finalPrice, test_name: test.test_name, name: test.name, test_type_uuid: test.test_type_uuid, uuid: test.uuid,})),
          type: sample.type,
          is_rnd: sample.is_rnd
        }));
        this.$refs.billing_invoice.customBills.forEach(customBill => {
          invoiceItems.push({
            description: customBill.description ? customBill.description : (customBill.package.quick_books_name ? customBill.package.quick_books_name : customBill.package.name),
            basePrice: customBill.customPrice,
            customPrice: customBill.customPrice,
            customer_id: this.$refs.billing_invoice.customer.customer_id,
            discounts: [],
            extra_costs: 0,
            finalPrice: customBill.customPrice,
            package: customBill.package.quick_books_name ? customBill.package.quick_books_name : customBill.package.name,
            percentDiscount: 0,
            sample_id: "N/A",
            sample_uuid: "N/A",
            tests: [],
            type: "N/A",
            is_rnd: false,
            is_custom: true
          })
        })
        this.separatedLineItems.forEach(item => {
          invoiceItems.push({
            description: item.package,
            basePrice: item.price,
            customPrice: item.price,
            customer_id: this.$refs.billing_invoice.customer.customer_id,
            discounts: [],
            extra_costs: item.price,
            finalPrice: item.price,
            package: item.package,
            quantity: item.quantity,
            percentDiscount: 0,
            sample_id: "N/A",
            sample_uuid: "N/A",
            tests: [],
            type: '',
            is_rnd: false,
            is_custom: false
          })
        })
        const date = this.$moment().format('MM/DD/YYYY');
        bill = await bill.$update({
          customer_id: this.$refs.billing_invoice.customer.customer_id,
          customer_name: this.$refs.billing_invoice.customer.name,
          due_date: date,
          invoice_date: date,
          invoice_items: invoiceItems
        });
        await model.updateBatchStore([bill]);
        await this.$store.$db().model('samples').api().save({
          collection: invoiceItems.filter(sample => (sample.sample_uuid && sample.sample_id) && (sample.sample_uuid !== 'N/A' && sample.sample_id !== 'N/A')).map(sample => ({uuid: sample.sample_uuid, id: sample.sample_id, billing_approved: true, updated_by: this.$store.getters.id}))
        })
        // update local store samples to set billing_approved to true
        await this.generateNewBill();
        this.samplesForInvoice = [];
        this.separatedLineItems = [];
        this.savingInvoice = false;
      }
    },
}
</script>

<style scoped>

</style>
